// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RoleOut = zod.object({
  "description": zod.string(),
  "key": zod.string(),
  "label": zod.string()
});

export type RoleOut = zod.input<typeof RoleOut>;
export type RoleOutOutput = zod.output<typeof RoleOut>;
